/* eslint-disable react/prop-types */
import React, {
  Fragment, useState, useEffect,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Constants, { toISTDate, QUANTITY, DEFAULT_CUR_ROUND_OFF, } from '@Apis/constants';
import H3Text from '@Uilib/h3Text';
import {
  DatePicker, Drawer, Upload, Radio, Select, Popconfirm,
} from 'antd';
import H3Image from '@Uilib/h3Image';
import CustomerActions from '@Actions/customerActions';
import CustomStatusActions from '@Actions/configurations/customStatusActions';
import DocConfigActions from '@Actions/docConfigActions';
import closeIcon from '@Images/icons/icon-close-blue.png';
import { PlusCircleFilled, PlusOutlined, EditFilled } from '@ant-design/icons';
import SOActions from '@Actions/sales/soActions';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import SelectDepartment from '@Components/Common/SelectDepartment';
import ProductActions from '@Actions/productActions';
import Helpers from '@Apis/helpers';
import BarcodeReader from '@Components/Common/BarcodeReader';
import Crown from '@Images/crown2.png';
import CustomFieldV3 from '@Components/Common/CustomFieldV3';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import TagSelector from '@Components/Common/Selector/TagSelector';
import SelectAppUser from '@Components/Common/SelectAppUser';
import CustomFieldHelpers from '@Helpers/CustomFieldHelpers';
import CustomDocumentInputs from '@Components/Common/CustomDocumentInputs';
import FormLoadingSkull from '@Components/Common/formLoadingSkull';
import CustomDocumentColumns from '@Components/Common/CustomDocumentColumns';
import RichTextEditor from '@Components/Common/RichTextEditor';
import InvoiceActions from '@Actions/invoiceActions';
import TagActions from '@Actions/tagActions';
import CustomerForm from '../../Customer/CustomerHome/CreateCustomer/CustomerForm';
import SelectCustomer from '../../../Common/SelectCustomer';
import {
  INITIAL_STATE, handleDeleteHelper, handleProductChangeValueHelper, handleProductChangeHelper, toggleBatchInnerHelper, toggleBatchHelper, addNewRowHelper, customLineInputChangeHelper, getBatches, createConsumptionOrderHelper, customInputChangeHelper, handleQuantityChangeHelper, updateBatchValueHelper, handleMultiProductChangeHelper, getDataSource, getBatchesForAMC
} from './consumptionHelpers';
import ErrorHandle from '../../../Common/ErrorHandle';
import consumptionErrors from './consumptionErrors';
import PRZButton from '../../../Common/UI/PRZButton';
import PRZConfirmationPopover from '../../../Common/UI/PRZConfirmationPopover';
import PRZInput from '../../../Common/UI/PRZInput';
import PRZText from '../../../Common/UI/PRZText';
import ConsumptionLines from './ConsumptionLines';
import { getAvailableQty } from '../../Invoice/InvoiceForm/helpers';
import './style.scss';
import DocumentNumberSeqInput from '../../../Admin/Common/DocumentNumberSeqInput';
import AddressSelector from '@Components/Common/FormUtils/AddressSelecter';

const uploadButton = (
  <div>
    <PlusOutlined />
    <div style={{ marginTop: 8 }}>Upload</div>
  </div>
);

const ConsumptionForm = (props) => {
  const {
    createInvoiceLoading, getInvoiceByIdLoading, updateInvoiceLoading, getProductsSuccess, getCustomers, user, selectedSO, match, getDocConfigInvoiceLoading,
    getProductByIdLoading, getDocCFV2, getOrgStatus, MONEY, location, getOrgStatusSalesOrderLoading, cfV2DocConsumption,
    selectedSOForPs, isCarryForward, getDocConfig, selectedAMCForConsumption, callback,
  } = props;

  const [state, setState] = useState(INITIAL_STATE(user));

  const {
    data, orderDate, attachments, description, showAddCustomer, selectedTenant, gstNumber,
    showNewCustomerModal, allStock, visibleColumns, isUserReadyForCF, isUserReady, selectedTags,
    cfConsumptionOrderDoc, cfConsumptionOrderLine, tenantDepartmentId, coNumber, selectedCustomerInfo, docSeqId, initialCoNumber,
    selectedCustomer, formSubmitted, withApproval, currentAction, accountManager, isFromSalesOrder, updateDocumentReason, termsAndConditions, shipToAddress, shipFromAddress, selectedAddressType, showAddressDrawer,
  } = state;

  const updateState = (key, value) => {
    setState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  useEffect(() => {
    setState(INITIAL_STATE(user));
    const tenantInfo = user?.user_tenants?.find((item) => item?.tenant_id === user?.tenant_info?.tenant_id);
    updateState('selectedTenant', user?.tenant_info?.tenant_id);
    updateState('currentSelectedTenantInfo', tenantInfo);
    updateState('shipFromAddress', user?.tenant_info?.default_shipping_address_info);
    const entityName = 'CONSUMPTION_ORDER';

    const payload = {
      orgId: user?.tenant_info?.org_id,
      entityName,
    };

    getDocCFV2(payload);
    getOrgStatus({ orgId: user?.tenant_info?.org_id, entityName: 'SALES_ORDER', orderType: entityName }, () => { });

    sessionStorage.setItem('staticReservations', JSON.stringify({}));

    return () => {
      updateState('isUserReadyForCF', false);
    };
  }, []);
  useEffect(() => {
    getDocConfig(selectedTenant, 'CONSUMPTION_ORDER', (doc) => {
      const termsData = doc?.find((item) => (item?.document_type === 'CONSUMPTION_ORDER_DOWNLOAD'))?.allowed_fields?.find((field) => (field?.field_name === 'default_t_and_c'))?.field_value;
      if (termsData) {
        updateState('termsAndConditions', termsData);
      }
    });
  }, [selectedTenant]);

  useEffect(() => {
    const departmentLevelStock = user?.tenant_info?.inventory_config?.settings?.department_level_stock;

    // Custom Fields
    if (cfV2DocConsumption) {
      const lineCFs = CustomFieldHelpers.getCfStructure(cfV2DocConsumption?.data?.document_line_custom_fields?.filter((item) => item?.is_active), false);

      setState((prevState) => ({
        ...prevState,
        cfConsumptionOrderDoc: CustomFieldHelpers.getCfStructure(cfV2DocConsumption?.data?.document_custom_fields, true),
        cfConsumptionOrderLine: lineCFs,
        visibleColumns: CustomFieldHelpers.updateVisibleColumns(cfV2DocConsumption?.data?.document_line_custom_fields, prevState?.visibleColumns),
        data: prevState.data.map((item) => ({ ...item, lineCustomFields: lineCFs })),
        isUserReadyForCF: true,
      }));
    }
    if (!match?.params?.invoiceId && !tenantDepartmentId) {
      const tenantDepartmentId = departmentLevelStock ? user?.tenant_info?.default_department_for_sales : user?.tenant_info?.default_store_id;
      updateState('tenantDepartmentId', tenantDepartmentId);
    }
  }, [cfV2DocConsumption, tenantDepartmentId, selectedTenant]);

  useEffect(() => {
    if (cfV2DocConsumption?.data?.success && selectedAMCForConsumption) {
      sessionStorage.setItem('staticReservations', JSON.stringify({}));
      const consumptionCreateFrom = selectedAMCForConsumption?.sales_order_lines;
      const oldCustomField = selectedAMCForConsumption?.custom_fields || [];
      const salesOrderLines = [];
      for (let i = 0; i < consumptionCreateFrom?.length; i++) {
        const orderLine = consumptionCreateFrom[i];
        const parentKey = uuidv4();
        const batches = getBatches(Helpers.batchSelectionMethod(orderLine?.default_outwards_method || Helpers.getBatchMethod(orderLine), orderLine?.available_batches, orderLine?.quantity), Math.min(orderLine?.quantity + Number(orderLine?.free_quantity), Helpers.getValueTotalInObject(orderLine?.available_batches, 'available_qty')), orderLine?.uom_info?.[0], orderLine?.product_sku_info?.uom_info, null, parentKey, false, true);
        const orderLineQty = ['NON_STORABLE', 'SERVICE', 'BUNDLE'].includes(orderLine?.product_sku_info?.product_type) ? orderLine?.quantity : Math.min(orderLine?.quantity, getAvailableQty(orderLine, batches, state, { ...props }, (newState) => setState((prevState) => ({ ...prevState, ...newState }))));

        const documentLineCustomFields = cfV2DocConsumption?.data?.document_line_custom_fields.filter((item) => item?.is_active);
        const systemCustomFields = orderLine?.product_sku_info?.system_custom_fields || [];
        const availableBatches = orderLine?.available_batches?.filter((item) => !item?.is_rejected_batch) || [];
        const availableQtyTotal = Helpers.getValueTotalInObject(availableBatches, 'available_qty');
        const orderLineQuantity = Number(orderLineQty);
        const oldLineCustomFields = orderLine?.custom_fields || [];
        const mergedArrayForLinesCfs = CustomFieldHelpers.mergeCustomFields(documentLineCustomFields, oldLineCustomFields);

        const discountValue = orderLine?.is_discount_in_percent ? Number.parseFloat(Number(orderLine?.line_discount_percentage).toFixed(DEFAULT_CUR_ROUND_OFF)) : Number.parseFloat(Number(orderLine?.line_discount_amount).toFixed(DEFAULT_CUR_ROUND_OFF));
        const taxableValue = orderLine?.is_discount_in_percent ? (orderLineQuantity * orderLine.unit_price) * (1 - discountValue / 100) : Math.max(orderLineQuantity * orderLine.unit_price - discountValue, 0);
        const unitDiscountValue = Number(discountValue / Number(orderLineQuantity)).toPrecision(DEFAULT_CUR_ROUND_OFF);

        salesOrderLines.push({
          key: parentKey,
          asset1: orderLine?.product_sku_info?.assets?.[0]?.url,
          product_sku_name: orderLine?.product_sku_info?.product_sku_name,
          product_category_info: orderLine.product_sku_info?.product_category_info,
          showFreebie: Number(orderLine?.free_quantity) > 0,
          quantity: orderLineQty,
          consumption_quantity: orderLineQty,
          so_quantity: orderLine?.quantity,
          so_free_quantity: orderLine?.free_quantity || 0,
          free_quantity: ['NON_STORABLE', 'SERVICE', 'BUNDLE'].includes(orderLine?.product_sku_info?.product_type) ? (orderLine?.free_quantity || 0) : (Math.min(orderLine?.free_quantity, getAvailableQty(orderLine, batches, state, { ...props }, (newState) => setState((prevState) => ({ ...prevState, ...newState }))) - orderLineQty) || 0),
          unitPrice: QUANTITY(orderLine?.unit_price) || 0,
          hsn_code: orderLine?.hsn_code || orderLine?.product_sku_info?.hsn_code,
          uomId: Number(orderLine?.uom_id),
          uomGroup: Number(orderLine?.group_id),
          uom_info: orderLine?.uom_info?.[0],
          taxId: Number(orderLine?.tax_id),
          taxInfo: orderLine?.tax_group_info,
          child_taxes: Helpers.computeTaxation(taxableValue, orderLine?.tax_group_info, user?.tenant_info?.state, (selectedAMCForConsumption?.billing_address_info?.state || selectedAMCForConsumption?.sales_order_info?.billing_address_info?.state || selectedAMCForConsumption?.source_address?.state))?.tax_info?.child_taxes,
          discount: discountValue,
          lineDiscountType: orderLine?.is_discount_in_percent ? 'Percent' : 'Amount',
          unitDiscount: unitDiscountValue,
          showUnitDiscount: !orderLine?.is_discount_in_percent && unitDiscountValue > 0,
          order_line_id: orderLine?.order_line_id,
          delivery_challan_line_id: orderLine?.delivery_challan_line_id,
          tenant_product_id: orderLine?.tenant_product_id,
          product_batches: batches,
          expiry_days: orderLine?.product_sku_info?.expiry_days,
          product_sku_info: orderLine?.product_sku_info,
          remarks: orderLine?.remarks || '',
          remarkRequired: !!orderLine?.remarks?.replace(/<[^>]+>/g, ''),
          sales_account_name: user?.tenant_info?.tally_configuration?.sales_account_name,
          batchConsumptionMethod: orderLine?.default_outwards_method || Helpers.getBatchMethod(orderLine),
          lineCustomFields: mergedArrayForLinesCfs?.map((field) => ({
            ...field,
            fieldValue: field?.fieldName === 'Rate'
              ? QUANTITY(orderLine?.unit_price)
              : field?.fieldName === 'Quantity'
                ? Math.min(orderLineQuantity, availableQtyTotal)
                : field?.fieldValue,
          })),
          bundle_products: orderLine?.bundle_products?.map((item) => {
            const lineKey = uuidv4();
            const bundleDiscountValue = orderLine?.is_discount_in_percent ? Number.parseFloat(Number(item?.line_discount_percentage).toFixed(DEFAULT_CUR_ROUND_OFF)) : Number.parseFloat(Number(item?.line_discount_amount).toFixed(DEFAULT_CUR_ROUND_OFF));
            const bundleTaxableValue = orderLine?.is_discount_in_percent ? (item?.quantity * item?.unit_price * Number(100 - bundleDiscountValue) / 100) : ((item?.quantity * item?.unit_price) - bundleDiscountValue);
            return {
              ...item,
              parentKey,
              key: lineKey,
              unitPrice: QUANTITY(item?.unit_price) || 0,
              uomId: Number(item?.uom_id),
              uomGroup: Number(item?.group_id),
              uom_info: item?.uom_info?.[0],
              taxId: Number(item?.tax_group_info?.tax_id),
              taxInfo: item?.tax_group_info,
              child_taxes: Helpers.computeTaxation(bundleTaxableValue, item?.tax_group_info, user?.tenant_info?.state, (selectedAMCForConsumption?.billing_address_info?.state || selectedAMCForConsumption?.sales_order_info?.billing_address_info?.state || selectedAMCForConsumption?.source_address?.state))?.tax_info?.child_taxes,
              product_sku_name: item?.product_sku_info?.product_sku_name,
              so_quantity: item?.quantity,
              expiry_days: item?.product_sku_info?.expiry_days,
              product_sku_info: item?.product_sku_info,
              batchConsumptionMethod: item?.default_outwards_method || Helpers.getBatchMethod(item),
              product_batches: getBatches(item?.available_batches, Math.min(item?.quantity, Helpers.getValueTotalInObject(item?.available_batches, 'available_qty')), item?.uom_info?.[0], item?.product_sku_info?.uom_info, null, lineKey, false, true),
            };
          }),
          manufacturingDateFormat: orderLine?.product_sku_info?.manufacturing_date_format,
          expiryDateFormat: orderLine?.product_sku_info?.expiry_date_format,
        });
      }
      setState((prevState) => ({
        ...prevState,
        selectedTenant: selectedAMCForConsumption?.tenant_id,
        selectedCustomer: selectedAMCForConsumption?.customer_id,
        selectedCustomerInfo: selectedAMCForConsumption?.customer_info,
        cfConsumptionOrderDoc: CustomFieldHelpers.mergeCustomFields(cfV2DocConsumption?.data?.document_custom_fields, selectedAMCForConsumption?.custom_fields),
        accountManager: selectedAMCForConsumption?.account_manager_id,
        data: salesOrderLines || [],
        shipToAddress: selectedAMCForConsumption?.shipping_address_info,
      }));
    }
  }, [selectedAMCForConsumption, cfV2DocConsumption]);

  const toggleBatch = (record, adjustmentRow) => {
    toggleBatchHelper({ data }, props, record, adjustmentRow, (newState) => updateState('data', newState?.data));
  };

  const toggleBatchInner = (record, adjustmentRow) => {
    toggleBatchInnerHelper({ data }, props, record, adjustmentRow, (newState) => updateState('data', newState?.data));
  };

  const handleDelete = (key) => {
    handleDeleteHelper(state, props, key, (newState) => updateState('data', newState?.data));
  };

  const showNewCustomerInSelect = (value) => {
    updateState('selectedCustomer', value?.customer_id);
  };

  const handleProductChange = (tenantSku, key, productData) => {
    handleProductChangeHelper(state, props, tenantSku, key, productData, (newState) => {
      updateState('data', newState?.data);
    });
  };

  const handleMultiProductChange = (tenantSku, key, productData, callback) => {
    handleMultiProductChangeHelper(state, props, tenantSku, productData, (newData) => {
      if (callback) {
        callback();
      }

      setState((prevState) => ({
        ...prevState,
        data: [...prevState.data, ...newData],
      }));
    });
  };

  const handleProductChangeValue = (value, key) => {
    handleProductChangeValueHelper(state, props, value, key, (newState) => updateState('data', newState?.data));
  };

  const addNewRow = (callback) => {
    addNewRowHelper(state, props, callback, (newState) => {
      updateState('data', newState?.data);
    });
  };

  function createConsumptionOrder(withApproval) {
    createConsumptionOrderHelper(state, props, withApproval, { docLevelError, lineLevelError }, (newState) => {
      updateState('formSubmitted', newState?.formSubmitted);
    });
  }

  function customInputChange(fieldValue, cfId) {
    customInputChangeHelper(state, props, fieldValue, cfId, (newState) => updateState('cfConsumptionOrderDoc', newState?.cfConsumptionOrderDoc));
  }

  const customLineInputChange = (fieldValue, key) => {
    customLineInputChangeHelper(state, props, fieldValue, key, (newState) => updateState('data', newState?.data));
  };

  const handleQuantityChange = (record, value, freeValue, showFreebie) => {
    handleQuantityChangeHelper(record, value, freeValue, showFreebie, state, props, (newState) => updateState('data', newState?.data));
  };

  const updateBatchValue = (record, value, label, batchId) => {
    updateBatchValueHelper(record, value, label, batchId, state, props, (newState) => updateState('data', newState?.data));
  };

  const handleChangeTextArea = (html) => {
    updateState('termsAndConditions', html);
  };
  const departmentLevelStock = user?.tenant_info?.inventory_config?.settings?.department_level_stock;
  const barCoding = user?.tenant_info?.global_config?.sub_modules?.barcoding?.is_active;
  const packingSlip = user?.tenant_info?.sales_config?.sub_modules?.packing_slip?.is_active;
  const { docLevelError, lineLevelError } = consumptionErrors({
    match, selectedCustomer, location, tenantDepartmentId, orderDate, cfConsumptionOrderDoc, data, allStock, shipFromAddress, shipToAddress
  });
  return (
    <Fragment>
      <Drawer
        open={showNewCustomerModal}
        onClose={() => updateState('showNewCustomerModal', false)}
        width="720px"
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '680px' }}>
            <H3Text
              text="Add New Customer"
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => updateState('showNewCustomerModal', false)}
            />
          </div>
        </div>
        <CustomerForm
          callback={(createdCustomer) => {
            getCustomers(
              '',
              (selectedTenant),
              1,
              1000,
              '',
              (newCustomers) => {
                showNewCustomerInSelect(
                  newCustomers?.customers.filter(
                    (customer) => customer?.customer_id === createdCustomer.customer_id,
                  )[0],
                );
                updateState('showNewCustomerModal', false);
              },
            );
          }}
        />
      </Drawer>
      <Drawer
        open={showAddressDrawer}
        onClose={() => {
          updateState('showAddressDrawer', false);
          updateState('selectedAddressType', '');
        }}
        width="360"
        destroyOnClose
      >
        <AddressSelector
          title={
            selectedAddressType === 'TENANT_SHIP_FROM'
              ? 'Ship From'
              : 'Ship To'
          }
          selectedAddressId={
            selectedAddressType === 'TENANT_SHIP_FROM'
              ? shipFromAddress?.address_id
              : shipToAddress?.address_id
          }
          onAddressChange={(address) => {
            if (selectedAddressType === 'TENANT_SHIP_FROM') {
              updateState('shipFromAddress', address);
              updateState('showAddressDrawer', false);
            }
            if (selectedAddressType === 'CUSTOMER') {
              updateState('shipToAddress', address);
              updateState('showAddressDrawer', false);
            }
          }}
          entityId={selectedAddressType === 'TENANT_SHIP_FROM' ? selectedTenant : (selectedAddressType === 'CUSTOMER' ? selectedCustomer : null)}
          entityType={selectedAddressType === 'TENANT_SHIP_FROM' ? 'TENANT' : (selectedAddressType === 'CUSTOMER' ? 'CUSTOMER' : null)}
          tenantId={selectedTenant}
        />
      </Drawer>
      {getInvoiceByIdLoading ? (
        <FormLoadingSkull />
      ) : (
        <div className="form__wrapper form-component" style={{ paddingTop: (selectedSOForPs || selectedAMCForConsumption) ? '0px' : '90px' }}>
          {(formSubmitted && (!!docLevelError?.length || !!lineLevelError?.length)) && (
            <ErrorHandle message="Mandatory fields required" docLevelErrors={docLevelError} lineLevelErrors={lineLevelError} />
          )}
          <div className="ant-row">
            <div className="ant-col-md-24">
              <div className="form__section">
                <div className="flex-display flex-align-c mg-bottom-5 pd-right-15">
                  <H3Text text="PART A" className="form__section-title" />
                  <div className="form__section-line" />
                  <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                    <CustomDocumentInputs
                      customFields={cfConsumptionOrderDoc}
                      updateCustomFields={(cf) => updateState('cfConsumptionOrderDoc', cf)}
                    />
                  </div>
                </div>
                <div className="form__section-inputs mg-bottom-20">
                  <div className="ant-row">
                    <DocumentNumberSeqInput
                      valueFromProps={coNumber}
                      updateCase={match.params?.invoiceId}
                      setInitialDocSeqNumber={(value) => updateState('initialCoNumber', value)}
                      entityName="CONSUMPTION_ORDER"
                      docSeqId={docSeqId}
                      tenantId={selectedTenant}
                      onChangeFromProps={(event, newValue, seqId) => {
                        updateState('coNumber', newValue ? (newValue || '') : (event?.target?.value || ''));
                        updateState('docSeqId', seqId);
                      }}
                      docTitle="Consumption Order #"
                      formSubmitted={formSubmitted}
                    />
                    <div className="ant-col-md-6">
                      <div className="form__input-row" style={{ marginBottom: '10px' }}>
                        <H3Text
                          required
                          text="Select Location"
                          className="form__input-row__label"
                        />

                        <div className="form__input-row__input">
                          <TenantSelector
                            hideTitle
                            selectedTenant={selectedTenant}
                            showSearch={false}
                            onChange={(value) => {
                              const defaultDepForSales = user?.user_tenants?.find((item) => item?.tenant_id === value)?.default_department_for_sales;
                              const defaultDepId = user?.user_tenants?.find((item) => item?.tenant_id === value)?.tenant_department_info?.tenant_department_id;
                              const currentTenantInfo = user?.user_tenants?.find((item) => item?.tenant_id === value);
                              const shipFromAddInfo = user?.user_tenants?.find((item) => item?.tenant_id === value)?.default_shipping_address_info;
                              updateState('selectedTenant', value);
                              updateState('tenantDepartmentId', departmentLevelStock ? defaultDepForSales : defaultDepId);
                              updateState('currentSelectedTenantInfo', currentTenantInfo);
                              updateState('selectedCustomer', null);
                              updateState('selectedCustomerInfo', null);
                              updateState('gstNumber', null);
                              updateState('attachments', []);
                              updateState('data', [
                                {
                                  key: uuidv4(),
                                  asset1: '',
                                  product_sku_name: '',
                                  quantity: '',
                                  unitPrice: '',
                                  lot: 0,
                                  taxId: '',
                                  discount: 0,
                                  child_taxes: [{
                                    tax_amount: 0,
                                    tax_type_name: '',
                                  }],
                                  lineCustomFields: [],
                                },
                              ]);
                              updateState('shipFromAddress', shipFromAddInfo);
                              updateState('shipToAddress', null);
                            }}
                            placeholder="Select Business Unit"
                            labelClassName="form__input-row__label"
                            inputClassName="orgFormInput input"
                            includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.CREATE)}
                            loading={createInvoiceLoading || updateInvoiceLoading || getDocConfigInvoiceLoading}
                            disabled={createInvoiceLoading || updateInvoiceLoading || getDocConfigInvoiceLoading || match?.params?.invoiceId || selectedAMCForConsumption}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="ant-col-md-6">
                      <div
                        className="form__input-row"
                      >
                        <H3Text
                          required
                          text="Department"
                          className="form__input-row__label"
                        />
                        {(!match?.params?.invoiceId) ? (
                          <div className="form__input-row__input">
                            <SelectDepartment
                              hideTitle
                              tenantId={selectedTenant}
                              selectedDepartment={tenantDepartmentId}
                              onChange={(value) => {
                                updateState('tenantDepartmentId', value?.tenant_department_id);
                                updateState('departmentId', value.department_id);
                                updateState('data', [
                                  {
                                    key: uuidv4(),
                                    asset1: '',
                                    product_sku_name: '',
                                    quantity: '',
                                    unitPrice: '',
                                    lot: 0,
                                    taxId: '',
                                    discount: 0,
                                    child_taxes: [{
                                      tax_amount: 0,
                                      tax_type_name: '',
                                    }],
                                    lineCustomFields: cfConsumptionOrderLine,
                                  },
                                ]);
                                getProductsSuccess(null, false);
                              }}
                              emptyNotAllowed
                              loading={createInvoiceLoading || updateInvoiceLoading || getDocConfigInvoiceLoading}
                              disabled={createInvoiceLoading || updateInvoiceLoading || getDocConfigInvoiceLoading ||
                                selectedAMCForConsumption
                              }
                              labelClassName="form__input-row__label"
                              inputClassName="orgFormInput input"
                              tenentLevelDepartment
                              showSearch
                            />
                            {formSubmitted && !tenantDepartmentId && (
                              <div className="input-error">
                                *Please select a department
                              </div>
                            )}
                          </div>
                        ) : (
                          <div
                            className="form__input-row__input"
                            style={{ marginBottom: '10px' }}
                          >
                            <H3Text
                              text={selectedSO?.tenant_department_info?.alias_name || selectedSOForPs?.tenant_department_info?.alias_name}
                              style={{ padding: '7px' }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="ant-col-md-6">
                      <div className="form__input-row orgInputContainer">
                        <H3Text
                          required
                          text="Order Date"
                          className="form__input-row__label"
                        />
                        <div className={`form__input-row__input  ${(formSubmitted && !orderDate) ? 'form__input-row__input-error' : ''}`}>
                          <DatePicker
                            value={orderDate}
                            onChange={(value) => {
                              updateState('orderDate', value);
                            }}
                            style={{
                              border: '1px solid rgba(68, 130, 218, 0.2)',
                              borderRadius: '2px',
                              height: '28px',
                              padding: '1px 3px',
                              width: '100%',
                              background: 'white',
                            }}
                            disabled={createInvoiceLoading || updateInvoiceLoading || getDocConfigInvoiceLoading}
                            format="DD/MM/YYYY"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="ant-col-md-6">
                      {(match?.params?.invoiceId) ? (
                        <div className="form__input-row" style={{ marginBottom: '10px' }}>
                          <H3Text text="Customer" className="form__input-row__label" />
                          <div className="form__input-row__input">
                            <H3Text
                              text={selectedCustomerInfo?.customer_name}
                              style={{ padding: '7px' }}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="form__input-row">
                          <H3Text required text="Customer" className="form__input-row__label" />
                          <div className="form__input-row__input">
                            <SelectCustomer
                              showAddCustomer={showAddCustomer}
                              selectedCustomer={selectedCustomer}
                              addCustomer={() => updateState('showNewCustomerModal', true)}
                              hideTitle
                              onChange={(value) => {
                                const docCf = CustomFieldHelpers.postCfStructure(cfConsumptionOrderDoc?.filter((item) => (item?.isActive && item?.visible))) || [];
                                const customerCf = value?.custom_field_values?.filter((item) => (item?.is_active)) || [];
                                const mergedCf = CustomFieldHelpers.mergeCustomFields(docCf, customerCf) || [];

                                updateState('cfConsumptionOrderDoc', mergedCf);
                                updateState('selectedCustomer', value?.customer_id);
                                updateState('selectedCustomerInfo', value.customer_info);
                                updateState('gstNumber', value?.customer_info?.gst_number);
                                updateState('data', [
                                  {
                                    key: uuidv4(),
                                    asset1: '',
                                    product_sku_name: '',
                                    quantity: '',
                                    unitPrice: '',
                                    lot: 0,
                                    taxId: '',
                                    discount: 0,
                                    child_taxes: [{
                                      tax_amount: 0,
                                      tax_type_name: '',
                                    }],
                                    lineCustomFields: cfConsumptionOrderLine,
                                  },
                                ]);
                                updateState('shipToAddress', value?.customer_info?.shipping_address_details);
                              }}
                              tenantId={selectedTenant}
                              disabled={createInvoiceLoading || updateInvoiceLoading || getDocConfigInvoiceLoading || match?.params?.invoiceId || selectedAMCForConsumption}
                              containerClass="form__input-row"
                              inputClassName={`${(formSubmitted && !selectedCustomer) ? 'form__input-row__select-error' : ''}`}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="ant-col-md-6">
                      <div className="form__input-row">
                        <H3Text text="GST Number" className="form__input-row__label" />
                        <H3FormInput
                          name="a valid GST Number"
                          type="text"
                          containerClassName="orgInputContainer form__input-row__input"
                          labelClassName="orgFormLabel"
                          inputClassName="orgFormInput input"
                          placeholder=""
                          onChange={(e) => updateState('gstNumber', e.target.value)}
                          value={gstNumber}
                          showError={formSubmitted && (gstNumber?.trim() ? String(gstNumber)?.length !== 15 : false)}
                          disabled={createInvoiceLoading || updateInvoiceLoading || getDocConfigInvoiceLoading || match?.params?.invoiceId}
                        />
                      </div>
                    </div>
                    <div className="ant-col-md-6">
                      <div className="form__input-row " style={{ marginBottom: '10px' }}>
                        <div className="form__input-row__label">
                          Labels
                        </div>
                        <TagSelector
                          hideTitle
                          entityType="INVOICE"
                          selectedTags={selectedTags}
                          isMultiple
                          showSearch
                          onChange={(value) => {
                            updateState('selectedTags', value);
                          }}
                          maxTagCount="responsive"
                          placeholder="Select Tags"
                          isForm
                          containerWrapper="form__input-row__input"
                          disabled={createInvoiceLoading || updateInvoiceLoading || getDocConfigInvoiceLoading || match?.params?.invoiceId}
                        />
                      </div>
                    </div>
                    <div className="ant-col-md-6">
                      <div className="form__input-row">
                        <H3Text text="Sales Manager" className="form__input-row__label" />
                        <div className="form__input-row__input">
                          <SelectAppUser
                            hideTitle
                            containerClassName="orgInputContainer"
                            labelClassName="orgFormLabel"
                            inputClassName="orgFormInput"
                            selectedUser={accountManager}
                            onChange={(value) => updateState('accountManager', value)}
                            disabled={createInvoiceLoading || updateInvoiceLoading || getDocConfigInvoiceLoading || match?.params?.invoiceId || selectedAMCForConsumption}
                          />
                        </div>
                      </div>
                    </div>
                    {accountManager?.first_name && (
                      <div className="ant-col-md-6">
                        <div className="form__input-row">
                          <H3Text
                            text="Sales Manager"
                            className="form__input-row__label"
                          />
                          <div className="form__input-row__input">
                            <H3Text
                              text={accountManager?.first_name}
                              style={{ padding: '7px' }}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <CustomFieldV3
                      customFields={cfConsumptionOrderDoc}
                      customInputChange={(value, cfId) => customInputChange(value, cfId)}
                      formSubmitted={formSubmitted}
                      wrapperClassName="ant-col-md-6"
                      containerClassName="form__input-row"
                      labelClassName="form__input-row__label"
                      inputClassName="form__input-row__input"
                      errorClassName="form__input-row__input-error"
                      disableCase={createInvoiceLoading || updateInvoiceLoading}
                      hideTitle
                      isCarryForward={true}
                    />
                  </div>
                  <div className="ant-row">
                    <div className="ant-col-md-6">
                      <div className="form__input-row">
                        <H3Text text="Internal Remarks" className="form__input-row__label" />
                        <div className="form__input-row__input">
                          <textarea
                            rows="5"
                            cols="50"
                            value={description}
                            onChange={(e) => updateState('description', e.target.value)}
                            disabled={createInvoiceLoading}
                            style={{
                              resize: 'none',
                              backgroundColor: 'rgb(239, 239, 239)',
                              border: 'none',
                              borderRadius: '4px',
                              marginRight: '15px',
                              height: '103px',
                              padding: '4px 8px',
                              width: '100%',
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="ant-col-md-6">
                      <div className="form__input-row">
                        <H3Text className="form__input-row__label" text="Attachment" />
                        <Upload
                          action={Constants.UPLOAD_FILE}
                          listType="picture-card"
                          fileList={attachments}
                          disabled={createInvoiceLoading}
                          onChange={(fileListData) => {
                            updateState('attachments',
                              fileListData?.fileList?.map((item) => ({
                                ...item,
                                url: item?.response?.response?.location || item?.url,
                              })));
                          }}
                          multiple
                        >
                          {attachments?.length >= 20 ? null : uploadButton}
                        </Upload>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form__section">
                <div className="flex-display flex-align-c mg-bottom-5 pd-right-15">
                  <H3Text text="PART B" className="form__section-title" />
                  <div className="form__section-line" />
                </div>
                <div className="ant-row">
                  <div className="ant-col-md-8">
                    <div className="form__input-row">
                      <H3Text
                        required
                        text="Ship To"
                        className="form__input-row__label"
                      />
                      <div
                        className={`form__input-row__address__wrapper ${formSubmitted &&
                          !shipToAddress
                          ? 'form__input-row__address-error'
                          : ''
                          } ${!selectedCustomer
                            ? 'form__input-row__address-disabled'
                            : ''
                          }`}
                      >
                        <div className="form__input-row__address">
                          {shipToAddress && (
                            <div className="form__input-row__address-info">
                              <div className="form__input-row__address-l1">
                                {shipToAddress?.address1}
                              </div>
                              <div className="form__input-row__address-l2">
                                {`${shipToAddress?.city}, ${shipToAddress?.state}, ${shipToAddress?.postal_code}, ${shipToAddress?.country}`}
                              </div>
                            </div>
                          )}
                          {!shipToAddress && (
                            <H3Text
                              text="Select address.."
                              className="form__input-row__address-placeholder"
                            />
                          )}
                          <div
                            className="form__input-row__address-icon"
                            onClick={() => {
                              if (!selectedCustomer) return;
                              updateState('selectedAddressType', 'CUSTOMER');
                              updateState('showAddressDrawer', true);
                            }}
                          >
                            <EditFilled /> Update
                          </div>
                        </div>
                        {formSubmitted && !shipToAddress && (
                          <div className="input-error">
                            *Please select ship to address
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="ant-col-md-8">
                    <div className="form__input-row">
                      <H3Text
                        required
                        text="Ship From"
                        className="form__input-row__label"
                      />
                      <div
                        className={`form__input-row__address__wrapper ${formSubmitted &&
                          !shipFromAddress
                          ? 'form__input-row__address-error'
                          : ''
                          } ${!selectedTenant
                            ? 'form__input-row__address-disabled'
                            : ''
                          }`}
                      >
                        <div className="form__input-row__address">
                          {shipFromAddress && (
                            <div className="form__input-row__address-info">
                              <div className="form__input-row__address-l1">
                                {shipFromAddress?.address1}
                              </div>
                              <div className="form__input-row__address-l2">
                                {`${shipFromAddress?.city}, ${shipFromAddress?.state} ${shipFromAddress?.postal_code}, ${shipFromAddress?.country}`}
                              </div>
                            </div>
                          )}
                          {!shipFromAddress && (
                            <H3Text
                              text="Select address.."
                              className="form__input-row__address-placeholder"
                            />
                          )}
                          <div
                            className="form__input-row__address-icon"
                            onClick={() => {
                              if (!selectedTenant) return;
                              updateState('selectedAddressType', 'TENANT_SHIP_FROM');
                              updateState('showAddressDrawer', true);
                            }}
                          >
                            <EditFilled /> Update
                          </div>
                        </div>
                        {formSubmitted && !shipFromAddress && (
                          <div className="input-error">
                            *Please select ship from address
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="form__lines-wrapper">
            {tenantDepartmentId && (
              <ConsumptionLines
                title={() => (
                  <div className="form-title__wrapper">
                    <H3Text
                      text={`Consumption Lines (${data?.filter(
                        (item) => item.product_sku_name?.length > 0,
                      )?.length
                        })`}
                      className="form__input-row__label"
                    />
                    &nbsp; &nbsp;
                    <CustomDocumentColumns
                      visibleColumns={visibleColumns}
                      setVisibleColumns={(val) => updateState('visibleColumns', val)}
                      customColumns={cfConsumptionOrderLine}
                      data={data}
                      updateData={(updatedData) => updateState('data', updatedData)}
                    />
                  </div>
                )}
                allStock={allStock}
                toggleAllStock={() => updateState('allStock', !allStock)}
                handleDelete={handleDelete}
                handleProductChange={handleProductChange}
                handleProductChangeValue={handleProductChangeValue}
                data={getDataSource(data)}
                addNewRow={() => addNewRow()}
                updateData={(updatedData) => updateState('data', updatedData)}
                formSubmitted={formSubmitted}
                loading={
                  createInvoiceLoading
                  || getDocConfigInvoiceLoading
                  || getProductByIdLoading
                }
                tenantDepartmentId={tenantDepartmentId}
                tenantId={selectedTenant}
                selectedCustomer={selectedCustomer}
                visibleColumns={visibleColumns}
                cfConsumptionOrderLine={cfConsumptionOrderLine}
                customInputChange={customInputChange}
                customLineInputChange={(value, key) => customLineInputChange(value, key)}
                handleQuantityChange={handleQuantityChange}
                toggleBatch={(batch, adjustmentRow) => toggleBatch(batch, adjustmentRow)}
                toggleBatchInner={(batch, adjustmentRow) => toggleBatchInner(batch, adjustmentRow)}
                isFromSalesOrder={isFromSalesOrder}
                updateBatchValue={(record, value, label, batchId) => updateBatchValue(record, value, label, batchId)}
                isCarryForward={isCarryForward}
                handleMultiProductChange={handleMultiProductChange}
                isFromAMC={selectedAMCForConsumption}

              />
            )}
          </div>

          <div className="form__data-wrapper">
            <div className="ant-row">
              <div className="ant-col-md-24">
                <div
                  className={`new-row-button ${data?.find((item) => !(item?.product_sku_id || item?.product_sku_info?.product_sku_id)) ? 'new-row-button__disabled' : ''}`}
                  onClick={() => {
                    if (!data?.find((item) => !(item?.product_sku_id || item?.product_sku_info?.product_sku_id))) addNewRow();
                  }}
                >
                  <span className="new-row-button__icon">
                    <PlusCircleFilled />
                  </span>
                  <div>New Item</div>
                </div>
              </div>
            </div>
          </div>

          <div className="ant-row">
            <div className="ant-col-md-24" style={{ marginBottom: '10px' }} />
            <div className="ant-col-md-12">
              <div className="form__data-tc">
                <label className="orgFormLabel">
                  Terms and Conditions
                </label>
                <RichTextEditor
                  onChange={(value) => handleChangeTextArea(value)}
                  value={termsAndConditions}
                  disabled={createInvoiceLoading || updateInvoiceLoading || getDocConfigInvoiceLoading}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="form__footer">
        {(match?.url?.includes('/update')) ? (
          <Fragment>
            {/* <PRZConfirmationPopover
              title="Are you sure you want to update?"
              content={(
                <Fragment>
                  <PRZText text="Reason" required />
                  <PRZInput
                    placeholder="Enter update reason"
                    value={updateDocumentReason}
                    onChange={(e) => setState((prevState) => ({
                      ...prevState,
                      updateDocumentReason: e.target.value,
                    }))}
                  />
                </Fragment>
              )}
              onConfirm={() => {
                updateState('currentAction', 'SAVE_AS_DRAFT');
                if (!createInvoiceLoading) {
                  createConsumptionOrder(false);
                }
              }}
              confirmButtonText="Confirm"
              cancelButtonText="Back"
              confirmDisabled={!updateDocumentReason}
            >
              <PRZButton
                type="default"
                wrapperStyle={{ marginRight: '10px' }}
                buttonStyle={{
                  width: '130px',
                  height: '40px',
                  border: '1px solid #2d7df7',
                  color: '#2d7df7',
                }}
                isLoading={
                  currentAction === 'SAVE_AS_DRAFT'
                  && ((!withApproval && createInvoiceLoading)
                    || updateInvoiceLoading || getDocConfigInvoiceLoading || getOrgStatusSalesOrderLoading)
                }
                disabled={createInvoiceLoading || updateInvoiceLoading || getDocConfigInvoiceLoading || !packingSlip}
              >
                Save as Draft
              </PRZButton>
            </PRZConfirmationPopover> */}
            <PRZConfirmationPopover
              title="Are you sure you want to update?"
              content={(
                <Fragment>
                  <PRZText text="Reason" required />
                  <PRZInput
                    placeholder="Enter update reason"
                    value={updateDocumentReason}
                    onChange={(e) => setState((prevState) => ({
                      ...prevState,
                      updateDocumentReason: e.target.value,
                    }))}
                  />
                </Fragment>
              )}
              onConfirm={() => {
                updateState('currentAction', 'SAVE_AND_ISSUE');
                if (!createInvoiceLoading) {
                  createConsumptionOrder(true);
                }
              }}
              confirmButtonText="Confirm"
              cancelButtonText="Back"
              confirmDisabled={!updateDocumentReason}
            >
              <PRZButton
                isLoading={
                  currentAction === 'SAVE_AND_ISSUE'
                  && ((withApproval && createInvoiceLoading)
                    || updateInvoiceLoading || getDocConfigInvoiceLoading || getOrgStatusSalesOrderLoading)
                }
                disabled={createInvoiceLoading || updateInvoiceLoading || getDocConfigInvoiceLoading}
                buttonStyle={{ width: '130px', height: '40px' }}
              >
                Save and Issue
              </PRZButton>
            </PRZConfirmationPopover>
          </Fragment>
        ) : (
          <Fragment>
            {/* <PRZButton
              type="default"
              onClick={() => {
                updateState('currentAction', 'SAVE_AS_DRAFT');
                if (!createInvoiceLoading) {
                  createConsumptionOrder(false);
                }
              }}
              isLoading={
                currentAction === 'SAVE_AS_DRAFT'
                && ((!withApproval && createInvoiceLoading)
                  || updateInvoiceLoading || getDocConfigInvoiceLoading || getOrgStatusSalesOrderLoading)
              }
              disabled={createInvoiceLoading || updateInvoiceLoading || getDocConfigInvoiceLoading}
              wrapperStyle={{ marginRight: '10px' }}
              buttonStyle={{
                width: '130px',
                height: '40px',
                border: '1px solid #2d7df7',
                color: '#2d7df7',
              }}
            >
              Save as Draft
            </PRZButton> */}
            <PRZButton
              onClick={() => {
                updateState('currentAction', 'SAVE_AND_ISSUE');
                if (!createInvoiceLoading) {
                  createConsumptionOrder(true);
                }
              }}
              isLoading={((createInvoiceLoading) || getDocConfigInvoiceLoading) && currentAction === 'SAVE_AS_DRAFT'}
              disabled={createInvoiceLoading || getDocConfigInvoiceLoading}
              buttonStyle={{ width: '130px', height: '40px' }}
            >
              Save and Issue
            </PRZButton>
          </Fragment>
        )}
        {!packingSlip && (
          <Popconfirm
            placement="topRight"
            title="This feature is not accessible within your current plan to use this feature contact us."
            onConfirm={() => window.Intercom('showNewMessage')}
            okText="Contact Us"
            cancelText="Cancel"
          >
            <img
              className="barcode-restrict"
              src={Crown}
              alt="premium"
              style={{
                marginLeft: '8px',
                marginTop: '5px',
              }}
            />
          </Popconfirm>
        )}

        {/* <div className="form-barcode__wrapper" style={{ display: 'flex' }}>
          {!barCoding && (
            <Popconfirm
              placement="topRight"
              title="This feature is not accessible within your current plan to use this feature contact us."
              onConfirm={() => window.Intercom('showNewMessage')}
              okText="Contact Us"
              cancelText="Cancel"
            >
              <img className="barcode-restrict" src={Crown} alt="premium" />
            </Popconfirm>
          )}
          <BarcodeReader
            productTypes={['STORABLE', 'SERVICE', 'BUNDLE', 'NON_STORABLE']}
            isSalesProduct
            excludedProducts={data?.map((item) => JSON.stringify(item?.product_sku_id)) || []}
            tenantDepartmentId={tenantDepartmentId}
            excludeOutOfStock
            filterReservedQuantity
            onSearch={(tenantSku) => {
              if (data[data?.length - 1]?.product_sku_id) {
                addNewRow((key) => handleProductChange(tenantSku, key));
              } else {
                handleProductChange(tenantSku, data[data?.length - 1]?.key);
              }
            }}
            disabled={!barCoding}
          />
        </div> */}

      </div>
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, SOReducers, PurchaseOrderReducers, CustomerReducers, ProductReducers, CFV2Reducers, CustomStatusReducers, DocConfigReducers, InvoiceReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  selectedSO: SOReducers.selectedSO,
  cfV2DocConsumption: CFV2Reducers.cfV2DocConsumption,
  selectedProduct: ProductReducers.selectedProduct,
  getProductByIdLoading: ProductReducers.getProductByIdLoading,
  getCustomersLoading: CustomerReducers.getCustomersLoading,
  getCustomerByIdLoading: CustomerReducers.getCustomerByIdLoading,
  orgStatusSalesOrder: CustomStatusReducers.orgStatusSalesOrder,
  getOrgStatusSalesOrderLoading: CustomStatusReducers.getOrgStatusSalesOrderLoading,
  docConfigSO: DocConfigReducers.docConfigSO,
  getDocConfigInvoiceLoading: DocConfigReducers.getDocConfigInvoiceLoading,
  orgStatusInvoice: CustomStatusReducers.orgStatusInvoice,
  createInvoiceLoading: InvoiceReducers.createInvoiceLoading,
  updateInvoiceLoading: InvoiceReducers.updateInvoiceLoading,
  getInvoiceByIdLoading: InvoiceReducers.getInvoiceByIdLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getCustomers: (keyword, tenantId, page, limit, customerId, callback) => dispatch(CustomerActions.getCustomers(keyword, tenantId, page, limit, customerId, callback)),
  createSO: (payload, callback) => dispatch(SOActions.createSO(payload, callback)),
  createInvoice: (payload, callback) => dispatch(InvoiceActions.createInvoice(payload, callback)),
  updateSO: (payload, callback) => dispatch(SOActions.updateSO(payload, callback)),
  getSO: (payload, callback) => dispatch(SOActions.getSO(payload, callback)),
  getSOById: (payload, callback) => dispatch(SOActions.getSOById(payload, callback)),
  getProductById: (tenantId, productSkuId, tenantDepartmentId, callback, filterReservedBatches, productSkuIds) => dispatch(ProductActions.getProductById(tenantId, productSkuId, tenantDepartmentId, callback, filterReservedBatches, productSkuIds)),
  updateSOStatus: (payload, callback) => dispatch(SOActions.updateSOStatus(payload, callback)),
  getDocCFV2Success: (customFields) => dispatch(CFV2Actions.getDocCFV2Success(customFields)),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getProductsSuccess: (products, forOffers) => dispatch(ProductActions.getProductsSuccess(products, forOffers)),
  getOrgStatus: (payload, callback) => dispatch(CustomStatusActions.getOrgStatus(payload, callback)),
  getDocConfig: (tenantId, entityName, callback) => dispatch(DocConfigActions.getDocConfig(tenantId, entityName, callback)),
  createTag: (payload, callback) => dispatch(TagActions.createTag(payload, callback)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ConsumptionForm));
